const STANDARD_TO_KEYBOARD_ROUTES = {
  '/': '/keyboard',
  '/dashboard': '/keyboard/dashboard',
  '/products': '/keyboard/product',
  '/customers': '/keyboard/customers',
  '/taxes': '/keyboard/taxes',
  '/settings': '/keyboard/settings',
  '/settings/fields': '/keyboard/settings/fields',
  '/settings/custom-fields': '/keyboard/settings/custom-fields',
  '/ledger': '/keyboard/ledger',
};

const KEYBOARD_TO_STANDARD_ROUTES = {
  '/keyboard': '/dashboard',
  '/keyboard/dashboard': '/dashboard',
  '/keyboard/product': '/products',
  '/keyboard/customers': '/customers',
  '/keyboard/taxes': '/taxes',
  '/keyboard/settings': '/settings',
  '/keyboard/settings/fields': '/settings/fields',
  '/keyboard/settings/custom-fields': '/settings/custom-fields',
  '/keyboard/ledger': '/ledger',
};

const KEYBOARD_MENU_TO_STANDARD = {
  dashboard: '/dashboard',
  invoices: '/invoices',
  quotations: '/quotations',
  'estimated-invoices': '/estimated-invoices',
  ledger: '/ledger',
  product: '/products',
  customers: '/customers',
  taxes: '/taxes',
  settings: '/settings',
};

function normalize(pathname) {
  if (!pathname) return '/';
  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export function mapStandardToKeyboardPath(pathname) {
  const normalized = normalize(pathname);

  if (STANDARD_TO_KEYBOARD_ROUTES[normalized]) {
    return STANDARD_TO_KEYBOARD_ROUTES[normalized];
  }

  if (normalized.startsWith('/invoices')) {
    return `/keyboard${normalized}`;
  }

  if (normalized.startsWith('/quotations')) {
    return `/keyboard${normalized}`;
  }

  if (normalized.startsWith('/estimated-invoices')) {
    return `/keyboard${normalized}`;
  }

  if (normalized.startsWith('/products')) {
    return '/keyboard/product';
  }

  if (normalized.startsWith('/customers')) {
    return '/keyboard/customers';
  }

  if (normalized.startsWith('/taxes')) {
    return '/keyboard/taxes';
  }

  if (normalized.startsWith('/settings')) {
    if (normalized.startsWith('/settings/fields')) {
      return '/keyboard/settings/fields';
    }
    if (normalized.startsWith('/settings/custom-fields')) {
      return '/keyboard/settings/custom-fields';
    }
    return '/keyboard/settings';
  }

  if (normalized.startsWith('/ledger')) {
    return '/keyboard/ledger';
  }

  return '/keyboard';
}

export function mapKeyboardToStandardPath(pathname, fallback = '/dashboard') {
  const normalized = normalize(pathname);

  if (!normalized.startsWith('/keyboard')) {
    return normalized;
  }

  if (KEYBOARD_TO_STANDARD_ROUTES[normalized]) {
    if (normalized === '/keyboard') {
      return normalize(fallback || '/');
    }
    return KEYBOARD_TO_STANDARD_ROUTES[normalized];
  }

  if (/^\/keyboard\/invoices\/[^/]+\/actions$/.test(normalized)) {
    const id = normalized.split('/')[3];
    return `/invoices/view/${id}`;
  }

  if (normalized.startsWith('/keyboard/invoices')) {
    return normalized.replace('/keyboard', '');
  }

  if (normalized.startsWith('/keyboard/quotations')) {
    return normalized.replace('/keyboard', '');
  }

  if (normalized.startsWith('/keyboard/estimated-invoices')) {
    return normalized.replace('/keyboard', '');
  }

  const menuMatch = normalized.match(/^\/keyboard\/([^/]+)$/);
  if (menuMatch) {
    const key = menuMatch[1];
    if (KEYBOARD_MENU_TO_STANDARD[key]) {
      return KEYBOARD_MENU_TO_STANDARD[key];
    }
  }

  return normalize(fallback || '/dashboard');
}
